import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

export type ContactMessageStatus = "new" | "read" | "answered" | "archived";
export type ContactMessageTopic = "general" | "course" | "payment" | "teaching" | "technical";

export interface ContactMessage {
  id: number;
  name: string;
  email: string;
  phone: string | null;
  topic: ContactMessageTopic;
  subject: string;
  message: string;
  status: ContactMessageStatus;
  userId: number | null;
  handledById: number | null;
  handledAt: string | null;
  internalNote: string | null;
  createdAt: string;
  updatedAt: string;
  /** Yuboruvchining hisobi, tizimga kirgan bo'lsa (pochtani o'qiganda qo'shiladi). */
  user?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    avatarUrl: string | null;
  } | null;
  handledBy?: { id: number; firstName: string; lastName: string } | null;
}

export interface ContactMessageStats {
  total: number;
  new: number;
  read: number;
  answered: number;
  archived: number;
}

export interface CreateContactMessageData {
  name: string;
  email: string;
  phone?: string;
  topic?: ContactMessageTopic;
  subject: string;
  message: string;
}

export interface ContactMessageFilter {
  page?: number;
  limit?: number;
  status?: ContactMessageStatus;
  topic?: ContactMessageTopic;
  search?: string;
  sortBy?: string;
  order?: "ASC" | "DESC";
}

export interface UpdateContactMessageData {
  status: ContactMessageStatus;
  internalNote?: string;
}

/** Bog'lanish API — backend'dagi `ContactController` ning ko'zgusi. */
export class ContactApi extends BaseApi {
  private readonly baseUrl: string = "/contact";

  /** Ommaviy: bog'lanish formasidan xabar yuboradi. */
  submit(data: CreateContactMessageData) {
    return this.request.post<{ id: number }, ApiResponse<{ id: number }>>(this.baseUrl, data);
  }

  /** Moderator/admin: kiruvchi xabarlar (sahifalangan). */
  list(filter: ContactMessageFilter) {
    return this.request.get<ContactMessage[], Pagination<ContactMessage>>(this.baseUrl, {
      params: filter,
    });
  }

  /** Moderator/admin: holatlar bo'yicha sonlar. */
  getStats() {
    return this.request.get<ContactMessageStats, ApiResponse<ContactMessageStats>>(
      `${this.baseUrl}/stats`,
    );
  }

  /** Moderator/admin: bitta xabarni o'qiydi (yangisi o'qilgan deb belgilanadi). */
  getOne(id: number) {
    return this.request.get<ContactMessage, ApiResponse<ContactMessage>>(`${this.baseUrl}/${id}`);
  }

  /** Moderator/admin: ko'rib chiqish holatini yoki ichki izohni o'zgartiradi. */
  update(id: number, data: UpdateContactMessageData) {
    return this.request.patch<ContactMessage, ApiResponse<ContactMessage>>(
      `${this.baseUrl}/${id}`,
      data,
    );
  }

  /** Admin: xabarni yumshoq o'chiradi. */
  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}

export const contactApi = new ContactApi();
